import { routes } from '@platform/core/lib/routes';
import type { ICrumb } from '@platform/navigation';

/**
 * Крихти сторінки модуля в розділі «Налаштування» (прототип v4 cust-form / cust-module без inMod, чиста функція): «Простір › Налаштування ›
 * Форми › Форма «Справа»» чи «Простір › Налаштування › Модулі › Справи» — простір веде на Головну, «Налаштування» — на огляд розділу,
 * розділ — на «Форми» / «Встановлені модулі», останній рівень — поточна сторінка.
 */
export function customizeCrumbs(
  ws: { id: string; name: string }, customize: string, section: { key: string; label: string }, current: string,
): ICrumb[] {
  return [
    { label: ws.name, to: routes.home() },
    { label: customize, to: routes.customize() },
    { label: section.label, to: routes.customize(section.key) },
    { label: current },
  ];
}
